import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const EVSApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRegistrosEVS = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("evs", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearRegistroEVS = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("evs", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteRegistroEVS = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`evs/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getRegistrosEVS,
        crearRegistroEVS,
        deleteRegistroEVS,

        cargando,
    };
};
